<template>
  <div class="body">
    <el-card class="box_card">
      <div class="patent_content">
        <div class="patent_content_box flex flex-middle flex-between flex-wrap">
          <div class="patent_content_b_t bold">患者列表 &nbsp;&nbsp;</div>
          <div class="patent_content_b_r flex flex-middle">
            <!-- <div class="flex flex-middle">
              <span class="title-patent">标签选择</span>
              <el-select size="small" v-model="selectValue" multiple placeholder="全部(多选)">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div> -->
            <el-input
              clearable
              size="small"
              v-model="searchValue"
              placeholder="请输入患者姓名查询"
              prefix-icon="el-icon-search"
              class="patent-search-input"
              @clear="getPatientList"
              @keyup.enter.native="getPatientList"
            ></el-input>
            <el-button type="primary" plain icon="el-icon-search" size="small" class="search-btn" @click="getPatientList"
              >搜索患者</el-button
            >
            <el-button type="success" plain icon="el-icon-plus" size="small" class="search-btn" @click="addPatient">新增患者</el-button>
          </div>
        </div>
        <div class="patient_box" v-loading="loadingPatient" element-loading-text="患者加载中..." element-loading-spinner="el-icon-loading">
          <div v-for="(item, index) in listData" :key="index" @click="goPatientFiles(item)" class="itmeBox green" style="background: #fff">
            <div class="itmeBox-t bold">
              {{ item.cml_full_name }}|
              <span :style="{ color: item.cml_Gender == '女' ? '#F596B0' : '#000' }"> {{ item.cml_Gender }} </span>
              | {{ item.cml_Age }}岁
            </div>
            <div class="tag-box">
              <el-tag v-for="(item2, idx) in item.Customer_tag_library" :key="idx" size="mini" class="tagList-item">{{
                item2.glol_name
              }}</el-tag>
            </div>
            <div class="patient_box_b">
              <div class="flex flex-middle patient_box_b_item">
                <img src="@/assets/img/phone.png" />
                <span>{{ item.cml_mobile_phone }}</span>
              </div>
              <div class="flex flex-middle  patient_box_b_item2">
                <img src="@/assets/img/idcard.png" />               
                <span>{{ item.cml_Customer_ID ? item.cml_Customer_ID : '' }}</span>
              </div>
            </div>
            <!-- <div class="patient_logo">
              <img v-if="item.cml_Gender == '女'" src="https://picture.hwason.cn/image/png/101518188122003776.png" alt="" />
              <img v-if="item.cml_Gender == '男'" src="https://picture.hwason.cn/image/png/101518093735035584.png" alt="" />
            </div> -->
          </div>
        </div>

        <div class="bottom_pagination">
          <div>
            <span>合计<span style="color: #2d99d7; font-weight: bold; margin: 0 10px"> {{ totalNumber }}</span>人</span>
          </div>
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="100"
          >
          </el-pagination> -->
        </div>
      </div>

      <el-dialog
        title="新增患者"
        :visible.sync="visibleAdd"
        width="30%"
        top="240px"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form ref="patientForm" :model="patientForm" :rules="rules" label-width="120px">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model.trim="patientForm.name" placeholder="请输入患者姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别：" prop="sex">
            <el-radio-group v-model="patientForm.sex">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-bottom: 30px" label="年龄：" prop="age">
            <el-input v-model.trim="patientForm.age" type="number" placeholder="请输入患者年龄">
              <el-select v-model="ageUnit" slot="append" placeholder="" style="width: 60px">
                <el-option label="岁" value="岁"></el-option>
                <el-option label="月" value="月"></el-option>
                <el-option label="天" value="天"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 30px" label="手机：" prop="phone">
            <el-input v-model.trim="patientForm.phone" type="number" placeholder="请输入患者手机号"></el-input>
          </el-form-item>
        </el-form>
        <template slot="footer">
          <el-button @click="cancelAddPatient" style="width: 80px">取消</el-button>
          <el-button @click="submitForm" type="primary" plain style="width: 80px">确定</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  name: 'Query',
  data() {
    var checkphone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'));
      } else if (!this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('输入正确格式的手机号!'));
      } else {
        callback();
      }
    };
    return {
      loadingPatient: false,
      currentPage: 1,
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        }
      ],
      clearable: true,
      selectValue: '',
      searchValue: '', //搜索值
      listData: [
        // {
        //   cml_full_name: '',
        //   cml_Gender: '',
        //   cml_Age: 65,
        //   Customer_tag_library: [{ glol_name: '' }],
        //   cml_mobile_phone: '',
        //   cml_Customer_ID: ''
        // }
      ],
      visibleAdd: false, //增加患者展示隐藏
      patientForm: {
        age: '',
        name: '',
        sex: '男',
        phone: ''
      },
      rules: {
        phone: [{ required: true, validator: checkphone, trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [{ required: true, message: '请输入年龄', trigger: 'blur' }]
      },
      ageUnit: '岁',
      totalNumber: 0
    };
  },
  created() {
    this.getPatientList();
  },
  mounted() {
    var that = this;
  },
  beforeDestroy() {},
  methods: {
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    //打开患者档案
    goPatientFiles(item) {
      let that = this;
      that.$router.push({ path: '/patientFiles', query: { customerId: item.cml_Customer_ID } });
    },
    // 获取患者列表
    getPatientList() {
      const that = this;
      that.loadingPatient = true; //加载提示
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cml_full_name: that.searchValue,
        glol_code: "''",       
        cal_code: clinicInfo.cal_code
      };
      const params = {
        token: clinicInfo.token,
        workid: 'cc5b15d2-1a7a-aab6-27f4-4274073ca4db',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          // console.log('患者列表：：', res);
          that.loadingPatient = false; //加载提示
          that.listData = res.Channel_customer_relationship.slice(0, 299);;
          this.totalNumber = res.Channel_customer_relationship.length;
        })
        .catch((err) => {
          that.loadingPatient = false; //加载提示
          that.$message.error('抱歉，患者加载失败');
        });
    },

    handleSizeChange(val) {},
    handleCurrentChange(val) {},
    addPatient() {
      const that = this;
      that.patientForm.name = '';
      that.patientForm.sex = '男';
      that.patientForm.phone = '';
      that.patientForm.age = '';
      this.visibleAdd = true;
    },
    // 取消增加
    cancelAddPatient() {
      let that = this;
      that.patientForm.name = '';
      that.patientForm.sex = '男';
      that.patientForm.phone = '';
      that.patientForm.age = '';
      that.$refs.patientForm.resetFields();
      that.visibleAdd = false;
    },
    //确认增加
    submitForm() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      that.$refs.patientForm.validate(async (valid) => {
        if (valid) {
          let dataP = {
            cal_code: clinicInfo.hsp_code, //诊所编码
            cal_name: clinicInfo.hsp_name, //诊所名称
            cml_full_name: that.patientForm.name,
            cml_Gender: that.patientForm.sex,
            cml_ID_number: '',
            cml_Date_of_birth: '',
            cml_Age: that.patientForm.age,
            cml_mobile_phone: that.patientForm.phone,
            cml_Contact_address: '',
            cml_Emergency_cell_phone: '',
            glol_id: '0'
          };
          const params = {
            token: clinicInfo.token,
            workid: 'e8d4352e-a820-fe30-dfb2-a416caf4d450',
            data: JSON.stringify(dataP)
          };
          request.post('/server/getdatalisapi.php', params).then((res) => {
            if (res.Channel_customer_relationship.IsOk === 'success') {
              that.$message.success('恭喜，增加成功');
              that.cancelAddPatient();
              that.getPatientList();
            } else {
              that.$message.error('抱歉，增加失败');
            }
            // console.log('患者列表：：', res);
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  // width, height 和订单报告首页统一
  width: 100%;
  height: calc(100vh - 90px);
  box-sizing: border-box;
  // 去除卡片的padding
  ::v-deep .el-card__body {
    padding: 0px !important;
    height: 100%;
  }
  .box_card {
    // height border-radius 和订单报告首页统一
    height: calc(100vh - 90px);
    box-sizing: border-box;
    border-radius: 30px 30px 0 0 !important;
    .patent_content {
      height: 100%;
      box-sizing: border-box;

      .patent_content_box {
        padding: 10px 30px;
        background: #f0feff;

        .patent_content_b_t {
          font-size: 20px;
          font-weight: bold;
          color: #2d99d7;
        }

        .patent_content_b_r {
          .title-patent {
            min-width: 70px;
            font-size: 16px;
            font-weight: 400;
            color: #333;
            margin-right: 35px;
          }

          .patent-search-input {
            width: 300px;
            margin-left: 20px;
          }

          .search-btn {
            margin-left: 5px;
          }
        }
      }

      .patient_box {
        width: 100%;
        height: calc(100% - 95px);
        overflow-y: auto;
        padding-top: 12px;
        padding-bottom: 12px;
        padding-left: 12px;
        box-sizing: border-box;

        .itmeBox {
          width: 262px;
          box-sizing: border-box;
          border-radius: 30px;
          display: inline-block;
          margin-left: 18px;
          margin-top: 18px;
          padding: 15px;
          cursor: pointer;
          padding-right: 10px;
          position: relative;
          // box-shadow: 4px 4px 3px #eeebeb;
          box-shadow: 0px 2px 10px 0px #cccccc;
          .patient_logo {
            position: absolute;
            right: -15px;
            top: -15px;
          }

          &.green {
            background: #effff4;
            // border: 1px solid #cdffdc;
          }
          &.purple {
            background: #f8f2ff;
            // border: 1px solid #ecddff;
          }
          .itmeBox-t {
            font-size: 20px;
            color: #333333;
          }
          .tag-box {
            // border: 1px solid red;
            height: 60px;
            overflow-y: auto;
            margin-top: 5px;
            .tagList-item {
              margin-right: 5px;
              margin-bottom: 5px;
              border-radius: 99px;
            }
          }

          &:hover {
            box-shadow: 0px 4px 10px 0px #a8a7a7;
          }
        }
        .patient_box_b {
          // border: 1px solid red;
          margin-top: 5px;
          .patient_box_b_item {
            margin-bottom: 12px;
          }
          .patient_box_b_item2 {
          //  border: 1px solid red;
           overflow: hidden;
           text-overflow:ellipsis;
           white-space: nowrap;
          }
          img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }

          span {
            color: #666666;
            font-size: 16px;
          }
        }
      }
    }
    .bottom_pagination {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: flex-end;
      // align-content: center;
      box-sizing: border-box;
      padding-right: 20px;
      // border: 1px solid red;
    }
  }
}
</style>
